<!--
 * @Author: yyl
 * @Date: 2025-06-26 08:55:40
 * @LastEditTime: 2025-08-21 15:54:41
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/components/home/CardListDate.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="card">
    <div class="card-title flex items-center content-space-between">
      <div class="card-title--left">
        <i class="el-icon-data-board"></i>
        {{ params.title }}
      </div>

      <div class="card-title--right" @click="handleGoListClick">更多></div>
    </div>

    <div>
      <div
        v-for="(item, index) in params.articles"
        :key="item.id"
        style="
          padding: 10px;
          background: #fff;
          border-bottom: 1px dashed #eaebed;
        "
      >
        <div v-if="index === 0" @click="handleGoDetailClick(item)">
          <div style="font-size: 14px" class="item-title">{{ item.title }}</div>
          <div style="padding: 10px 0; font-size: 13px">{{ item.content }}</div>
          <div style="font-size: 12px">
            {{ item.created_at }}-{{ item.day }}
          </div>
        </div>

        <div v-else class="flex" @click="handleGoDetailClick(item)">
          <div
            style="
              background: #e0edfe;
              text-align: center;
              color: #2e64ad;
              width: 72px;
              height: 72px;
            "
          >
            <div style="padding: 15px 0 4px">{{ item.day }}</div>
            <div style="font-size: 12px">{{ item.created_at }}</div>
          </div>

          <div style="margin: 4px 10px; flex: 1" class="item-title">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
    },
  },

  data() {
    return {}
  },

  // watch: {
  //   params: {
  //     deep: true,
  //     immediate: true, // （可选）立即触发一次
  //     handler() {
  //       this.getData()
  //     },
  //   },
  // },

  mounted() {},

  methods: {
    // getData() {
    //   const articles = this.params.articles || []

    //   this.oneData = articles[0] || {}
    //   this.listData = articles.filter((item) => item.id != this.oneData.id)
    // },

    handleGoListClick() {
      this.$router.push(
        `/list?section_id=${this.params.section_id}&title=${this.params.title}`
      )
    },
    handleGoDetailClick(item) {
      this.$router.push(`/article?id=${item.id}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  // height: 470px;
  color: #565656;
  font-size: 16px;
}

.card-title {
  padding: 0 4px;
  border-bottom: 3px solid #b4d13d;
}

.card-title--left {
  color: #42679f;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  padding: 14px 0;
}

.card-title--right {
  font-size: 14px;
  line-height: 18px;

  text-align: right;
  padding: 14px 0;
  cursor: pointer;
}

.card-image {
  display: block;
  width: 100%;
  height: 324px;
  // background-color: skyblue;
}

.card-content {
  font-size: 15px;
  padding: 10px 0;
  min-height: 42px;
  cursor: pointer;
  &:hover {
    color: #15458b;
    text-decoration: underline;
  }
}

.card-subtitle {
  font-size: 13px;
}

.item-title {
  cursor: pointer;
  &:hover {
    color: #15458b;
    text-decoration: underline;
  }
}
</style>
